<template>
  <div>
    <HTMLHeader></HTMLHeader>
    <div class="wrapper">
      <HTMLMenu></HTMLMenu>

      <div class="content">
        <div class="container">
          <div class="floating-buttons">
            <button :disabled="is_save" class="fl-button" type="button" v-on:click="save"><i class="fa fa-save"></i></button>
          </div>
          <h1>Nyitvatartás</h1>

          <div class="row">
            <div class="col-xs-2">
              <comboboxV2 @input="getElements" id="element_type_id" label="Típus" name="element_type_id" v-model="element_type_id" :options="element_types"/>
            </div>
            <div v-if="elements.length > 0" class="col-xs-2">
              <select2 style="width: 300px;" @onChange="getDates" label="Eszköz" name="element_id" id="element_id" :options="elements" v-model="element_id"/>
            </div>
          </div>

          <div v-show="element_id != 0">
            <p v-if="open_warning"><b>FIGYELEM!</b><br/>Ebben az ajtóban olyan zár található, melynek hosszan nyitva tartása annak meghibásodását okozhatja.<br/>Ennek az opciónak a használata itt nem javasolt.</p>

            <!-- Napos -->
            <h2>Nap</h2>

            <div v-if="item.deleted == undefined" v-for="(item, i) in items" style="display: flex">
              <comboboxV2 style="width: 200px; margin-right: 15px;" :id="'item_day_'+item.id" label="Nap" :name="'item_day_'+item.id" v-model="item.day" :options="days"/>
              <inputbox style="width: 200px; margin-right: 15px;" :datepicker="{noCalendar: true, enableTime:true}" label="Időpont -tól" v-bind:errors="errors" :id="'item_time_from_'+item.id" :name="'item_time_from_'+item.id" v-model="item.time_from"/>
              <inputbox style="width: 200px; margin-right: 15px;" :datepicker="{noCalendar: true, enableTime:true}" label="Időpont -ig" v-bind:errors="errors" :id="'item_time_to_'+item.id" :name="'item_time_to_'+item.id" v-model="item.time_to"/>
              <div class="form-group">
                <label class="form-label">&nbsp;</label>
                <button @click="removeItem(item)" type="button" class="button small"><i class="fa fa-trash"></i></button>
              </div>
            </div>

            <div style="display: flex">
              <comboboxV2 style="width: 200px; margin-right: 15px;" id="new_item_day" label="Nap" name="new_item_day" v-model="new_item.day" :options="days"/>
              <inputbox style="width: 200px; margin-right: 15px;" :datepicker="{noCalendar: true, enableTime:true, defaultDate: '00:00'}" label="Időpont -tól" v-bind:errors="errors" ref="new_item_time_from" id="new_item_time_from" name="new_item_time_from" v-model="new_item.time_from"/>
              <inputbox style="width: 200px; margin-right: 15px;" :datepicker="{noCalendar: true, enableTime:true, defaultDate: '00:00'}" label="Időpont -ig" v-bind:errors="errors" ref="new_item_time_to" id="new_item_time_to" name="new_item_time_to" v-model="new_item.time_to"/>
              <div class="form-group">
                <label class="form-label">&nbsp;</label>
                <button @click="addItem" type="button" class="button small"><i class="fa fa-plus"></i></button>
              </div>
            </div>

            <!-- Dátumos -->
            <h2>Dátum</h2>

            <div v-if="item.deleted == undefined" v-for="(item, i) in items_" style="display: flex">
              <inputbox style="width: 200px; margin-right: 15px;" :datepicker="{enableTime:false}" label="Dátum -tól" v-bind:errors="errors" :id="'item__date_from_'+item.id" :name="'item__date_from_'+item.id" v-model="item.date_from"/>
              <inputbox style="width: 200px; margin-right: 15px;" :datepicker="{noCalendar: true, enableTime:true}" label="Időpont -tól" v-bind:errors="errors" :id="'item__time_from_'+item.id" :name="'item__time_from_'+item.id" v-model="item.time_from"/>
              <inputbox style="width: 200px; margin-right: 15px;" :datepicker="{enableTime:false}" label="Dátum -ig" v-bind:errors="errors" :id="'item__date_to_'+item.id" :name="'item__date_to'+item.id" v-model="item.date_to"/>
              <inputbox style="width: 200px; margin-right: 15px;" :datepicker="{noCalendar: true, enableTime:true}" label="Időpont -ig" v-bind:errors="errors" :id="'item__time_to_'+item.id" :name="'item__time_to_'+item.id" v-model="item.time_to"/>
              <toggle id="new_item__close" label="Zárva" v-bind:errors="errors" :name="'item__close_'+item.id" v-model="item.close"/>
              <div class="form-group">
                <label class="form-label">&nbsp;</label>
                <button @click="removeItem_(item)" type="button" class="button small"><i class="fa fa-trash"></i></button>
              </div>
            </div>

            <div style="display: flex">
              <inputbox style="width: 200px; margin-right: 15px;" :datepicker="{enableTime:false}" label="Dátum -tól" v-bind:errors="errors" id="new_item__date_from" ref="new_item__date_from" name="new_item__date_from" v-model="new_item_.date_from"/>
              <inputbox style="width: 200px; margin-right: 15px;" :datepicker="{noCalendar: true, enableTime:true, defaultDate: '00:00'}" label="Időpont -tól" v-bind:errors="errors" ref="new_item__time_from" id="new_item__time_from" name="new_item__time_from" v-model="new_item_.time_from"/>
              <inputbox style="width: 200px; margin-right: 15px;" :datepicker="{enableTime:false}" label="Dátum -ig" v-bind:errors="errors" id="new_item__date_to" ref="new_item__date_to" name="new_item__date_to" v-model="new_item_.date_to"/>
              <inputbox style="width: 200px; margin-right: 15px;" :datepicker="{noCalendar: true, enableTime:true, defaultDate: '00:00'}" label="Időpont -ig" v-bind:errors="errors" ref="new_item__time_to" id="new_item__time_to" name="new_item__time_to" v-model="new_item_.time_to"/>
              <toggle id="new_item__close" label="Zárva" v-bind:errors="errors" name="new_item__close" v-model="new_item_.close"/>
              <div class="form-group">
                <label class="form-label">&nbsp;</label>
                <button @click="addItem_" type="button" class="button small"><i class="fa fa-plus"></i></button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <HTMLFooter></HTMLFooter>
    <ProgressInfo :show="is_save"/>
  </div>
</template>
<script>
import Vue from 'vue';

export default {
  components: {
  },

  data: function() {
    return {
      is_save: false,
      open_warning: false,
      element_types: [],
      element_type_id: 0,
      elements: [],
      element_id: 0,
      items: [],
      items_: [],
      errors: [],
      new_item: {
        id: 0,
        day: 0,
        time_from: '00:00',
        time_to: '00:00',
        added: 1
      },
      new_item_: {
        id: 0,
        date_from: '',
        date_to: '',
        time_from: '00:00',
        time_to: '00:00',
        added: 1,
        close: {
          value: 1,
          selected: false
        }
      },
      days: [{value:0,label:'Hétfő'},{value:1,label:'Kedd'},{value:2,label:'Szerda'},{value:3,label:'Csütörtök'},{value:4,label:'Péntek'},{value:5,label:'Szombat'},{value:6,label:'Vasárnap'}]
    }
  },

  mounted: function() {
    var _this = this;

    this.$root.checkRootUserHasSet(function() {
      _this.$root.ajax('opening/init/' + _this.$root.user.apikey, {
        method: 'GET',
        success: function(response) {
          _this.element_types = response.element_types;
        }
      });
    });
  },

  methods: {
    getDates: function() {
      var _this = this;

      this.errors = [];
      this.items = [];
      this.items_ = [];
      this.open_warning = false;

      if (this.element_id != 0) {
        this.$root.checkRootUserHasSet(function() {
          _this.$root.ajax('opening/dates/' + _this.element_id + '/' + _this.$root.user.apikey, {
            method: 'GET',
            success: function(response) {
              _this.items = response.items;
              _this.items_ = response.items_;
              if(response.open_warning == '1') {
                _this.open_warning = true;
              }
            }
          });
        });
      }
    },

    removeItem: function(item) {
      Vue.set(item, 'deleted', 1);
      Vue.delete(item, 'added');
    },

    removeItem_: function(item) {
      Vue.set(item, 'deleted', 1);
      Vue.delete(item, 'added');
    },

    addItem: function() {
      this.errors = [];

      if (!moment(this.new_item.time_from, 'HH:mm', true).isValid()) {
        this.errors.push({id: 'new_item_time_from', msg: 'Hibás időpont'});
      }

      if (!moment(this.new_item.time_to, 'HH:mm', true).isValid()) {
        this.errors.push({id: 'new_item_time_to', msg: 'Hibás időpont'});
      }

      if (this.errors.length == 0 && moment(this.new_item.time_from, 'HH:mm', true).isAfter(moment(this.new_item.time_to, 'HH:mm', true))) {
        this.errors.push({id: 'new_item_time_from', msg: 'Hibás időpont'});
      }

      if (this.errors.length == 0) {
        this.items.push(JSON.parse(JSON.stringify(this.new_item)));

        this.new_item = {
          id: this.$root.generateGUID(),
          day: 0,
          time_from: '00:00',
          time_to: '00:00',
          added: 1
        };

        this.$refs['new_item_time_from'].reinitFlatpickr();
        this.$refs['new_item_time_to'].reinitFlatpickr();
      }
    },

    addItem_: function() {
      this.errors = [];

      if (!moment(this.new_item_.date_from, 'YYYY-MM-DD', true).isValid()) {
        this.errors.push({id: 'new_item__date_from', msg: 'Hibás dátum'});
      }

      if (!moment(this.new_item_.date_to, 'YYYY-MM-DD', true).isValid()) {
        this.errors.push({id: 'new_item__date_to', msg: 'Hibás dátum'});
      }

      if (!moment(this.new_item_.time_from, 'HH:mm', true).isValid()) {
        this.errors.push({id: 'new_item__time_from', msg: 'Hibás időpont'});
      }

      if (!moment(this.new_item_.time_to, 'HH:mm', true).isValid()) {
        this.errors.push({id: 'new_item__time_to', msg: 'Hibás időpont'});
      }

      if (this.errors.length == 0 && moment(this.new_item_.date_from + ' ' + this.new_item_.time_from, 'YYYY-MM-DD HH:mm', true).isAfter(moment(this.new_item_.date_to + ' ' + this.new_item_.time_to, 'YYYY-MM-DD HH:mm', true))) {
        this.errors.push({id: 'new_item__time_from', msg: 'Hibás időpont'});
      }

      if (this.errors.length == 0) {
        this.items_.push(JSON.parse(JSON.stringify(this.new_item_)));

        this.new_item_ = {
          id: this.$root.generateGUID(),
          date_from: '',
          date_to: '',
          time_from: '00:00',
          time_to: '00:00',
          close: {
            value: 1,
            selected: false
          },
          added: 1
        };

        this.$refs['new_item__date_from'].reinitFlatpickr();
        this.$refs['new_item__date_to'].reinitFlatpickr();
        this.$refs['new_item__time_from'].reinitFlatpickr();
        this.$refs['new_item__time_to'].reinitFlatpickr();
      }
    },

    getElements: function() {
      var _this = this;

      this.element_id = 0;
      this.elements = [];
      this.items = [];
      this.items_ = [];

      if (this.element_type_id != 0) {
        this.$root.checkRootUserHasSet(function() {
          _this.$root.ajax('opening/elements/' + _this.element_type_id + '/' + _this.$root.user.apikey, {
            method: 'GET',
            success: function(response) {
              _this.elements = response.elements;
            }
          });
        });
      }
    },

    save: function() {
      var _this = this;
      this.errors = [];

      this.items.map(function(item, i) {
        if (item.deleted == undefined) {
          if (!moment(item.time_from, 'HH:mm', true).isValid()) {
            _this.errors.push({id: 'item_time_from_'+item.id, msg: 'Hibás időpont'});
          }

          if (!moment(item.time_to, 'HH:mm', true).isValid()) {
            _this.errors.push({id: 'item_time_to_'+item.id, msg: 'Hibás időpont'});
          }

          if (_this.errors.length == 0 && moment(item.time_from, 'HH:mm', true).isAfter(moment(item.time_to, 'HH:mm', true))) {
            _this.errors.push({id: 'item_time_from_'+item.id, msg: 'Hibás időpont'});
          }
        }
      });

      this.items_.map(function(item, i) {
        if (item.deleted == undefined) {
          if (!moment(item.date_from, 'YYYY-MM-DD', true).isValid()) {
            _this.errors.push({id: 'item__date_from_'+item.id, msg: 'Hibás dátum'});
          }

          if (!moment(item.date_to, 'YYYY-MM-DD', true).isValid()) {
            _this.errors.push({id: 'item__date_to_'+item.id, msg: 'Hibás dátum'});
          }

          if (!moment(item.time_from, 'HH:mm', true).isValid()) {
            _this.errors.push({id: 'item__time_from_'+item.id, msg: 'Hibás időpont'});
          }

          if (!moment(item.time_to, 'HH:mm', true).isValid()) {
            _this.errors.push({id: 'item__time_to_'+item.id, msg: 'Hibás időpont'});
          }

          if (_this.errors.length == 0 && moment(item.date_from + ' ' + item.time_from, 'YYYY-MM-DD HH:mm', true).isAfter(moment(item.date_to + ' ' + item.time_to, 'YYYY-MM-DD HH:mm', true))) {
            _this.errors.push({id: 'item__date_from_'+item.id, msg: 'Hibás dátum és időpont'});
          }
        }
      });

      if (this.errors.length == 0) {
        this.is_save = true;

        this.$root.checkRootUserHasSet(function() {
          _this.$root.ajax('opening/save/' + _this.$root.user.apikey, {
            method: 'POST',
            data: {
              items: _this.items,
              items_: _this.items_,
              element_id: _this.element_id
            },
            waitForSaveInfo: true,
            success: function(response) {
              _this.is_save = false;

              var tmp_element_id = _this.element_id;
              _this.getElements();
              _this.element_id = tmp_element_id;
              _this.getDates();
            }
          });
        });
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// opening.vue?9bbfd8ee